var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Header'),_c('Markets'),_c('Inovations'),_c('BusinessGroup'),_c('SharedNews')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }